import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { IKeyMetricsMap, ITest } from '../../../data/types';
import { formatDateWithTime } from '../../../utils/date';
import { roundValue } from '../../../utils/math';
import { testMetaString } from '../../../utils/testMetaString';
import { SelectBox } from '../../shared/form/SelectBox';
import { ListAvatar } from '../../shared/List/ListAvatar';
import {
  ListItem,
  ListItemCell,
  ListItemSafeText,
} from '../../shared/List/ListItem';
import { Metric } from '../../shared/Metric';

interface IProps {
  keyMetrics: IKeyMetricsMap;
  row: ITest;
  goToTestView: (t: ITest) => void;
  style: React.CSSProperties;
  selected?: boolean;
  onSelect?: (test: ITest, include: boolean) => void;
  viewed?: boolean;
  shape: number[];
  showingDisabledTests: boolean;
}
const ExportItem = (props: IProps): React.ReactElement => {
  const doOnSelect = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation();
    props.onSelect(props.row, !props.selected);
  };

  const clickHandler = (): void => {
    props.goToTestView(props.row);
  };
  const metricKey =
    // check keyMetrics are available
    !isEmpty(props.keyMetrics) &&
    // check keyMetric is defined for this test type
    props.keyMetrics[props.row.testType.id] &&
    // check this test has the keyMetric
    props.row[props.keyMetrics[props.row.testType.id].value] &&
    // check the keyMetric is an enabled metric
    props.row[props.keyMetrics[props.row.testType.id].value].value
      ? props.keyMetrics[props.row.testType.id].value
      : props.row.testType.defaultKey;

  const testTypeString = testMetaString(
    props.row.testType.abbr,
    props.row.tags
  );
  const trapClickEvent = (e: React.MouseEvent<HTMLElement>): void =>
    e.stopPropagation();

  return (
    <ListItem
      onClick={clickHandler}
      style={props.style}
      selected={props.viewed}
    >
      <ListItemCell style={{ flex: props.shape[0] }}>
        <ListAvatar
          entity={props.row.athlete}
          secondaryText={
            props.showingDisabledTests
              ? `${testTypeString}-DISABLED`
              : testTypeString
          }
        />
      </ListItemCell>
      <ListItemCell style={{ flex: props.shape[1] }}>
        <ListItemSafeText>
          <Metric
            value={roundValue(
              props.row[metricKey]?.value,
              props.row[metricKey]?.roundingPrecision
            )}
            units={
              props.row[metricKey]?.value !== 'N/A'
                ? props.row[metricKey]?.units
                : ''
            }
            label={props.row[metricKey]?.label}
          />
        </ListItemSafeText>
      </ListItemCell>
      <ListItemCell style={{ flex: props.shape[2] }}>
        <ListItemSafeText>
          {formatDateWithTime(props.row.timestamp)}
        </ListItemSafeText>
      </ListItemCell>
      <ListItemCell
        onClick={trapClickEvent}
        style={{ flex: props.shape[3], height: '100%' }}
      >
        <SelectBox onSelect={doOnSelect} selected={props.selected} />
      </ListItemCell>
    </ListItem>
  );
};

export { ExportItem };
